import { Info } from "@phosphor-icons/react";
import { useIntercom } from "react-use-intercom";

import { Button } from "common/components/ui/Button";

export default function RentedBanner() {
  const { show } = useIntercom();

  return (
    <article className="flex gap-x-2 rounded-3xl px-4 py-3 shadow-sm border border-yellow-400 bg-white">
      <Info weight="fill" size={16} />

      <div className="flex flex-col gap-y-2.5">
        <p className="text-xs">
          Please contact support if you have any issues with this account, or
          want to downgrade your Outreach Avatar subscription
        </p>

        <Button
          variant="secondary-black"
          size="sm"
          className="ml-auto"
          onClick={show}
        >
          Contact support
        </Button>
      </div>
    </article>
  );
}
